import type {UserProfile} from 'src/types/crm-mailbox';
import {showApiError} from 'src/action-creators/modal';
import type {Dispatch, ThunkAction, GetState} from 'src/reducers';
import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApiBff from 'src/utils/redux-api-bff';


const BASE_API_PATH = 'mailbox';

export const USER_PROFILE = 'crm-mailbox/user-profile';

type UserProfileAction = {
  type: typeof USER_PROFILE;
  payload: UserProfile | null | undefined;
};

export type CrmMailboxSettingsActions = UserProfileAction;

const receiveUserProfile = (payload: UserProfile): UserProfileAction => ({
  type: USER_PROFILE,
  payload,
});

export const fetchUserProfileDetails: (
  userEmailId: number,
) => ThunkAction<void> = flow()((userEmailId) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApiBff.post(`${BASE_API_PATH}/user-settings`, {
      userEmailId,
    }),
  ).then(
    (response: UserProfile) => {
      dispatch(receiveUserProfile(response));
    },
    (error) => {
      dispatch(showApiError(error, error?.responseBody?.message));
    },
  );
});

// @ts-expect-error - TS2322 - Type '(userEmailId: number, profileData: Partial<UserProfile> | null | undefined) => (dispatch: Dispatch) => Promise<void | UserProfile>' is not assignable to type '(userEmailId: number, profileData?: Partial<UserProfile> | null | undefined) => ThunkAction<UserProfile | null | undefined>'.
export const updateUserProfileDetails: (
  userEmailId: number,
  profileData?: Partial<UserProfile> | null | undefined,
) => ThunkAction<UserProfile | null | undefined> = flow()(
  (userEmailId, profileData) => (dispatch: Dispatch) => {
    return dispatch(
      reduxApiBff.post(`${BASE_API_PATH}/update-user-settings`, {
        ...(profileData ? profileData : {}),
        userEmailId,
      }),
    ).then(
      (response: UserProfile) => {
        dispatch(receiveUserProfile(response));
        return response;
      },
      (error) => {
        dispatch(showApiError(error, error?.responseBody?.message));
      },
    );
  },
);

export const uploadProfilePicture: (payload: {
  name: string;
  extension: string;
  file: File;
  userEmailId: number;
}) => ThunkAction<UserProfile | null | undefined> = flow()(
  (payload) => async (dispatch: Dispatch, getState: GetState) => {
    const userProfile = getState().crmMailbox.userProfile;
    try {
      // Step 1: Request a presigned URL from backend
      const {url} = await dispatch(
        reduxApiBff.post('mailbox/generate-presigned-url', {
          fileName: payload.name,
          extension: payload.extension,
          purpose: 'emailAttachments',
        }),
      );

      return dispatch(
        reduxApiBff.post('mailbox/generate-presigned-url', {
          fileName: payload.name,
          extension: payload.extension,
          purpose: 'emailAttachments',
        }),
      )
        .then(({url}) =>
          // Using fetch() directly instead of reduxApi because:
          // 1. We need to make a PUT request to S3's presigned URL which is outside our API domain
          // 2. reduxApi is configured only for our backend API endpoints
          fetch(url, {
            method: 'PUT',
            body: payload.file,
            headers: {
              'Content-Type': payload.file.type,
            },
          }).then(() => url),
        )
        .then((url) => {
          dispatch(
            updateUserProfileDetails(payload.userEmailId, {
              ...userProfile,
              emailContactInfoDTO: {
                //@ts-expect-error
                ...userProfile.emailContactInfoDTO,
                avatarInfo: {
                  type: 'url',
                  value: url,
                },
              },
            }),
          );
          return url;
        })
        .catch((error) => {
          dispatch(showApiError(error, error?.responseBody?.message));
        });
    } catch (error: any) {
      dispatch(showApiError(error, error?.responseBody?.message));
    }
  },
);
